module.exports = __webpack_public_path__ + "img/before-after-alone.e581ecdd.png";